/** Compte pour lequel l'application est montée dans ce document (docs/17 §4.8), lu par `api/client.ts` pour l'en-tête
 *  `X-Generex-Compte` : posé une fois au montage, il ne change plus jusqu'au rechargement de la page. Aucune
 *  dépendance : le client et le portail le lisent sans s'importer l'un l'autre. */

let scope: string | null = null;

/** Référence (`scope_ref`) du compte monté, ou null (mode hérité, écran de connexion, outils). */
export function mountedScope(): string | null {
  return scope;
}

/** Fixe le compte monté. Un document ne change jamais de compte : changer d'utilisateur recharge la page. */
export function setMountedScope(ref: string | null): void {
  scope = ref;
}
